import React from "react";
import HealthOpsChat from "@/components/organisms/HealthOpsChat";

function HealthOpsChatPage() {
  return (
    <div className="h-full flex items-center justify-center py-6">
      <div className="w-full" style={{ height: 'calc(100vh - 180px)' }}>
        <HealthOpsChat />
      </div>
    </div>
  );
}

export default HealthOpsChatPage;